module.exports = __webpack_public_path__ + "img/share-bg.708f6a16.png";